const defaultFilterValue = [
  { name: 'GTIN', type: 'number', operator: 'eq', value: '' },
  { name: 'Description', type: 'string', operator: 'contains', value: '' },
  { name: 'CompanyName', type: 'string', operator: 'contains', value: '' },
  { name: 'Brand', type: 'string', operator: 'contains', value: '' },
  { name: 'BrandSub', type: 'string', operator: 'contains', value: '' }
];

export default defaultFilterValue;